<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaTotens(empresaSelecionada)"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:[`item.situacao`]="{ item }">
            <v-chip small :color="(item.situacao || 'LIVRE') === 'OCUPADO' ? 'red' : 'green'" dark>
              {{ item.situacao || 'LIVRE' }}
            </v-chip>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-icon :color="item.ativo ? 'green' : 'red'">mdi-circle</v-icon>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">TOTENS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)"></v-spacer>
              <v-btn text @click="dialogoTotem = true" tile color="#2C2E83" :disabled="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia) ? empresaSelecionada == '' : false" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
                <v-icon left dark>add_circle</v-icon>Adicionar Totem
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="atualizarItem(item)" color="orange">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </template>
              <span>Atualizar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="editItem(item)" color="blue darken-3">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="deleteItem(item)" color="red" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>

      <v-dialog v-model="dialogoTotem" persistent max-width="600px" scrollable>
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-subtitle>*O preenchimento de todos os campos é obrigatório</v-card-subtitle>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" style="margin: 10px 0px 10px 0px">
                <p style="margin: 0px">Dados do totem</p>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="totem.descricao" outlined label="Descrição (nome da estação)" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="totem.mac" v-mask="'XX:XX:XX:XX:XX:XX'" outlined label="Endereço MAC" color="#94AAB4" hide-details dense :disabled="!(user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia))"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="totem.urlSite" outlined label="URL Site" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model.number="totem.tempoEsperaSegundos" type="number" outlined label="Tempo de Espera (segundos)" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
                <v-select v-model="totem.tipoCarregamento" :items="tiposCarregamento" outlined dense label="Tipo de Carregamento" hide-details></v-select>
              </v-col>
              <v-col cols="6" v-if="(user.tipo == 'ADMIN') || (user.tipo == 'GERENTE' && user.franquia) && totem.tipoCarregamento == 'KW'">
                <v-text-field v-model="totem.ocppChargePointId" outlined label="ID de Charge Point OCPP" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-switch style="margin: 5px" v-model="totem.ativo" label="ATIVO" color="#00253E" hide-details inset></v-switch>
              </v-col>
              <v-col cols="6">
                <v-select v-model="totem.situacao" :items="situacoes" item-text="text" item-value="value" outlined dense label="Situação" hide-details></v-select>
              </v-col>

              <v-col cols="12" style="margin: 10px 0px 10px 0px" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
                <p style="margin: 0px">Publicidade padrão</p>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
                <v-text-field v-model="totem.urlPublicidadePadrao" outlined label="Vídeo Padrão" color="#94AAB4" hide-details dense>
                  <template v-slot:append-outer>
                    <v-btn color="primary" icon x-small depressed :disabled="!isValidURL(totem.urlPublicidadePadrao)" @click="exibeVideo(totem.urlPublicidadePadrao)">
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" style="margin: 10px 0px 10px 0px">
                <p style="margin: 0px">Publicidade do cliente</p>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <span>Selecionar mídias ({{ midiasSelecionadas.length }} selecionada{{ midiasSelecionadas.length !== 1 ? 's' : '' }})</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div v-if="carregandoMidias" style="text-align: center; padding: 20px;">
                        <v-progress-circular indeterminate color="#2C2E83" size="32"></v-progress-circular>
                        <p style="margin-top: 10px; color: #666;">Carregando mídias...</p>
                      </div>
                      <div v-else-if="midiasDisponiveis.length === 0" style="padding: 20px; text-align: center;">
                        <v-alert type="info" outlined>
                          Nenhuma mídia disponível para esta empresa. Faça upload de mídias na seção de Mídias primeiro.
                        </v-alert>
                      </div>
                      <div v-else style="max-height: 400px; overflow-y: auto;">
                        <v-list dense>
                          <v-list-item v-for="midia in midiasDisponiveis" :key="midia.id" style="border-bottom: 1px solid #eee;">
                            <v-list-item-action>
                              <v-checkbox
                                v-model="midiasSelecionadas"
                                :value="midia.id"
                                color="#2C2E83"
                                hide-details
                                dense
                              ></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-avatar size="80" tile>
                              <img v-if="midia.tipo === 'IMAGEM'" :src="midia.url" :alt="midia.nome" style="object-fit: cover; width: 100%; height: 100%;" @error="handleImageError">
                              <video v-else-if="midia.tipo === 'VÍDEO'" :src="midia.url" style="object-fit: cover; width: 100%; height: 100%;" preload="metadata" muted></video>
                              <v-icon v-else-if="midia.tipo === 'PDF'" size="40" color="#EF5350">mdi-file-pdf</v-icon>
                              <v-icon v-else size="40" color="#666">mdi-file</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{ midia.nome || 'Sem nome' }}</v-list-item-title>
                              <v-list-item-subtitle>
                                <v-chip x-small :color="getTipoColor(midia.tipo)" dark style="margin-right: 5px;">
                                  {{ midia.tipo }}
                                </v-chip>
                                <span v-if="midia.tamanho">{{ (typeof midia.tamanho === 'number' ? midia.tamanho.toFixed(2) : midia.tamanho) }} KB</span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>

              <v-col cols="5">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  locale="pt-pt"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      light
                      v-model="dateFormattedInicio"
                      label="Expiração"
                      persistent-hint
                      append-icon="event"
                      @blur="date = parseDate(dateFormattedInicio)"
                      v-on="on"
                      outlined
                      dense
                      readonly
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="expiracao" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="7">
                <v-btn block color="success" @click="adicionaPublicidade" :disabled="midiasSelecionadas.length === 0 || !expiracao">
                  <v-icon left>mdi-plus</v-icon>
                  Adicionar {{ midiasSelecionadas.length }} mídia{{ midiasSelecionadas.length !== 1 ? 's' : '' }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <div v-if="publicidadesValidas.length == 0">
                  <v-alert style="margin: 0px" dark dense text outlined :value="true" color="warning" icon="info">Publicidades do cliente não informadas</v-alert>
                </div>
                <div v-else style="border: 1px #bbb solid; padding: 10px; border-radius: 5px">
                  <v-list dense style="padding: 0px">
                    <draggable
                      v-model="publicidadesValidas"
                      handle=".pub-drag-handle"
                      :animation="150"
                      ghost-class="pub-drag-ghost"
                      tag="div"
                    >
                      <div v-for="(item, index) in publicidadesValidas" :key="'pub-' + index + '-' + item.urlPublicidade">
                        <v-list-item style="padding: 0px">
                          <v-list-item-avatar size="120" tile>
                            <img v-if="isImageUrl(item.urlPublicidade)" :src="item.urlPublicidade" :alt="'Mídia ' + (index + 1)" style="object-fit: cover; width: 100%; height: 100%;" @error="handleImageError">
                            <video v-else-if="isVideoUrl(item.urlPublicidade)" :src="item.urlPublicidade" style="object-fit: cover; width: 100%; height: 100%;" preload="metadata" muted></video>
                            <v-icon v-else size="60" color="#666">mdi-file</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <p style="margin: 0px; font-weight: 500; word-break: break-all;">{{ getMidiaNome(item.urlPublicidade) || item.urlPublicidade }}</p>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <p style="margin: 5px 0px 0px 0px; color: #666;" v-if="item.expiracao">
                                Exibido até {{ formatarDataExpiracao(item.expiracao) }}
                              </p>
                              <p style="margin: 5px 0px 0px 0px; color: #999;" v-else>
                                Sem data de expiração
                              </p>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click="editarOpcao(item)">
                              <v-icon color="blue">edit</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="publicidadesValidas.length > 1"
                              icon
                              class="pub-drag-handle"
                              title="Arrastar para reordenar"
                            >
                              <v-icon color="blue">mdi-menu</v-icon>
                            </v-btn>
                            <v-btn icon @click="removerOpcao(item)">
                              <v-icon color="red">delete</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider v-if="index < publicidadesValidas.length - 1"></v-divider>
                      </div>
                    </draggable>
                  </v-list>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoTotem = false">Cancelar</v-btn>
            <v-btn text color="primary" @click="salvarTotem">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoExibeVideo" persistent max-width="600px">
        <v-card>
          <v-card-text style="padding: 0px">
            <video :src="videoExibido" width="100%" controls autoplay loop>
              Seu navegador não suporta o elemento <code>video</code>.
            </video>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogoExibeVideo = false" color="red">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import draggable from 'vuedraggable'
  export default {
    components: { Snackbar, draggable },
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      videoExibido: '',
      urlPublicidade: '',
      addUser: false,
      cadastroCategoria: false,
      dialogoTotem: false,
      dialogoExibeVideo: false,
      menu1: false,
      midiasDisponiveis: [],
      midiasSelecionadas: [],
      carregandoMidias: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Descrição', value: 'descricao' },
          { text: 'Endereço MAC', value: 'mac' },
          { text: 'Tipo de Carregamento', value: 'tipoCarregamento' },
            { text: 'Situação', value: 'situacao' },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      empresas: [],
      perfis: [],
      editedIndex: -1,
      totem: {
        descricao: "",
        mac: "",
        ativo: true,
        empresaId: "",
        urlPublicidadePadrao: "",
        urlPublicidadeCliente: [],
        tipoCarregamento: "TEMPO",
        situacao: 'LIVRE',
        urlSite: "",
        tempoEsperaSegundos: 0,
        qrCodeEstatico: true,
      },
      totemDefault: {
        descricao: "",
        mac: "",
        ativo: true,
        empresaId: "",
        urlPublicidadePadrao: "",
        urlPublicidadeCliente: [],
        tipoCarregamento: "TEMPO",
        situacao: 'LIVRE',
        urlSite: "",
        tempoEsperaSegundos: 0,
        qrCodeEstatico: true,
      },
      tiposCarregamento: [
        { text: 'Tempo', value: 'TEMPO' },
        { text: 'KW', value: 'KW' },
      ],
      situacoes: [
        { text: 'LIVRE', value: 'LIVRE' },
        { text: 'OCUPADO', value: 'OCUPADO' },
      ],
      totens: [],
      categorias: [],
      events: [],
      dateFormattedInicio: '',
      expiracao: '',
    }),

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj,
      }),
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar novo totem' : 'Editar totem'
      },  
      computedDateFormattedInicio () {
        return this.formatDate(this.expiracao)
      },
      publicidadesValidas: {
        get() {
          if (!this.totem.urlPublicidadeCliente || !Array.isArray(this.totem.urlPublicidadeCliente)) {
            return []
          }
          return this.totem.urlPublicidadeCliente.filter(item => {
            return item && item.urlPublicidade && item.urlPublicidade.trim() !== ''
          })
        },
        set(lista) {
          this.$set(this.totem, 'urlPublicidadeCliente', lista)
        },
      },
    },

    watch: {
      dialogoTotem(val) {
        if (val == false) {
          setTimeout(() => {
            this.totem = Object.assign({}, this.totemDefault)
            this.editedIndex = -1
            this.dateFormattedInicio = ''
            this.expiracao = ''
            this.midiasSelecionadas = []
            this.midiasDisponiveis = []
          }, 300)
        } else {
          // Carregar mídias quando o dialog abrir
          const empresaId = this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id
          if (empresaId) {
            this.carregaMidias(empresaId)
          }
        }
      },

      dialogoExibeVideo() {
        if (this.dialogoExibeVideo == false) {
          this.videoExibido = ''
        }
      },

      expiracao() {
        this.dateFormattedInicio = this.formatDate(this.expiracao)
      },

      empresaSelecionada() {
        // Recarregar mídias quando a empresa mudar e o dialog estiver aberto
        if (this.dialogoTotem && this.empresaSelecionada) {
          this.carregaMidias(this.empresaSelecionada)
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)) {
        this.carregaEmpresas()
      } else {
        this.carregaTotens(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        let filter

        if (this.user.tipo == 'GERENTE' && this.user.franquia) {
          filter = {
            where: {"franquia": this.user.franquia},
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }
        else {
          filter = {
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }
        
        await axios.get(baseApiUrl + 'Empresas?filter=' + JSON.stringify(filter) + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaTotens(empresaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []

        await axios.get(baseApiUrl + 'Totens?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })       
      },

      async carregaMidias(empresaId) {
        if (!empresaId) {
          this.midiasDisponiveis = []
          return
        }

        this.carregandoMidias = true
        this.midiasDisponiveis = []

        await axios.get(baseApiUrl + 'Uploads?filter={"where":{"empresaId":"' + empresaId + '"},"order":"created DESC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data && Array.isArray(response.data)) {
            this.midiasDisponiveis = response.data
          } else {
            this.midiasDisponiveis = []
          }
          this.carregandoMidias = false
        })
        .catch(() => {
          this.carregandoMidias = false
          this.midiasDisponiveis = []
        })
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.totem = Object.assign({}, item)
        if (this.totem.urlPublicidadeCliente && Array.isArray(this.totem.urlPublicidadeCliente)) {
          this.totem.urlPublicidadeCliente = JSON.parse(JSON.stringify(this.totem.urlPublicidadeCliente))
            .filter(pub => pub && pub.urlPublicidade && String(pub.urlPublicidade).trim() !== '')
        } else {
          this.totem.urlPublicidadeCliente = []
        }
        this.dialogoTotem = true
      },

      async deleteItem(item) {
        let vm = this
        var r = confirm('Deseja realmente excluir o totem: ' + item.descricao + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Totens/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            this.carregaTotens(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        }
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async salvarTotem() {
        var vm = this

        if (this.totem.descricao || this.totem.mac || this.totem.ativo) {
          if (this.totem.tipoCarregamento == 'KW' && !this.totem.ocppChargePointId) {
            vm.$refs.chamaSnackbar.snack("#F9A825", "O campo ID de Charge Point OCPP é obrigatório para o tipo de carregamento KW", "ATENÇÃO")
            return
          }

          this.totem.empresaId = this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id
          const payload = Object.assign({}, this.totem)
          payload.qrCodeEstatico = true
          payload.urlPublicidadeCliente = (payload.urlPublicidadeCliente || []).filter(pub =>
            pub && pub.urlPublicidade && String(pub.urlPublicidade).trim() !== ''
          )
          await axios.post(baseApiUrl + 'Totens/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), payload)
          .then(response => {
            if (response.data) {
              this.dialogoTotem = false
              this.carregaTotens(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos!", "ATENÇÃO")
        }
      },

      isValidURL(url) {
        try {
          new URL(url);
          return true;
        } catch (e) {
          return false;
        }
      },

      exibeVideo(video) {
        this.videoExibido = video
        this.dialogoExibeVideo = true
      },

      transformaData(data, formato) {
        return moment(data).format(formato);
      },

      formatarDataExpiracao(expiracao) {
        if (!expiracao) return 'Data inválida';
        try {
          // Tentar formatar a data
          let dataFormatada = expiracao.replace('.000Z', '-03:00');
          let dataMoment = moment(dataFormatada);
          if (dataMoment.isValid()) {
            return dataMoment.format('DD/MM/YYYY');
          }
          return 'Data inválida';
        } catch (e) {
          return 'Data inválida';
        }
      },

      adicionaPublicidade() {
        let vm = this

        if (this.midiasSelecionadas.length === 0 || !this.expiracao) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Selecione pelo menos uma mídia e informe a data de expiração!","ATENÇÃO")
          return
        }

        // Buscar as URLs das mídias selecionadas
        const midiasParaAdicionar = this.midiasDisponiveis.filter(m => this.midiasSelecionadas.includes(m.id))
        
        // Adicionar cada mídia selecionada
        midiasParaAdicionar.forEach(midia => {
          this.totem.urlPublicidadeCliente.push({
            "urlPublicidade": midia.url,
            "expiracao": this.expiracao + 'T00:00:00.000Z',
          })
        })

        // Limpar seleção
        setTimeout(() => {
          this.midiasSelecionadas = []
          this.expiracao = ''
          this.dateFormattedInicio = ''
        }, 50)
      },

      editarOpcao(item) {
        // Encontrar a mídia correspondente pela URL
        const midiaEncontrada = this.midiasDisponiveis.find(m => m.url === item.urlPublicidade)
        
        // Preencher data de expiração primeiro
        this.expiracao = item.expiracao.split('T')[0]
        this.dateFormattedInicio = this.formatDate(this.expiracao)
        
        // Remover da lista
        this.removerOpcao(item)
        
        // Preencher seleção de mídia após remover (usar setTimeout para garantir que a remoção foi processada)
        if (midiaEncontrada) {
          setTimeout(() => {
            this.midiasSelecionadas = [midiaEncontrada.id]
          }, 100)
        }
      },

      removerOpcao(opcao) {
        let listaFiltrada = this.totem.urlPublicidadeCliente.filter(function(item) {
          return item !== opcao;
        });

        this.totem.urlPublicidadeCliente = listaFiltrada
      },

      async atualizarItem(item) {
        this.isLoading = true
        let vm = this

        await axios.post(baseApiUrl + 'Totens/atualizar', {"totemId": item.id})
        .then(response => {
          if (response.data) {
            vm.$refs.chamaSnackbar.snack("green","Operação realizada!","SUCESSO")
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("red", "Problema ao realizar operação", "DESCULPE")
        })
        
        this.isLoading = false
      },

      getTipoColor(tipo) {
        switch(tipo) {
          case 'IMAGEM':
            return '#2196F3'
          case 'VÍDEO':
            return '#F44336'
          case 'PDF':
            return '#FF9800'
          case 'OUTRO':
            return '#757575'
          default:
            return '#757575'
        }
      },

      isImageUrl(url) {
        if (!url) return false
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp']
        const lowerUrl = url.toLowerCase()
        return imageExtensions.some(ext => lowerUrl.includes(ext)) || lowerUrl.includes('image')
      },

      isVideoUrl(url) {
        if (!url) return false
        const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.mkv']
        const lowerUrl = url.toLowerCase()
        return videoExtensions.some(ext => lowerUrl.includes(ext)) || lowerUrl.includes('video')
      },

      getMidiaNome(url) {
        if (!url) return ''
        const midia = this.midiasDisponiveis.find(m => m.url === url)
        return midia ? midia.nome : ''
      },

      handleImageError(e) {
        e.target.style.display = 'none'
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  .pub-drag-handle {
    cursor: grab;
  }

  .pub-drag-handle:active {
    cursor: grabbing;
  }

  .pub-drag-ghost {
    opacity: 0.6;
  }
</style>
